import React, { useState } from 'react';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Container,
  Avatar,
  Fade,
  Slide,
  IconButton,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  Link,
  Divider,
  Alert,
  CircularProgress
} from '@mui/material';
import {
  LockOutlined,
  Visibility,
  VisibilityOff,
  Email,
  Google,
  Facebook,
  Twitter
} from '@mui/icons-material';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth,db } from "./../../firebase";
import { useNavigate } from 'react-router';
import { collection, query, where, getDocs } from "firebase/firestore";
export default function SignInPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
   const navigate = useNavigate();
  const handleLogin = async (e) => {
  e.preventDefault();

  try {
    // Step 1: Check Firestore if email exists in 'applications'
    const q = query(collection(db, "applications"), where("email", "==", email));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      alert("Email not found in applications. Access denied.");
      return;
    }

    // Step 2: If found, allow Firebase Auth login
    await signInWithEmailAndPassword(auth, email, password);
    navigate("/blogs");
  } catch (error) {
    console.error(error);
    alert("Invalid credentials or login error.");
  }
};
  const handleSocialLogin = (provider) => {
    console.log(`Login with ${provider}`);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4
        }}
      >
        <Container component="main" maxWidth="sm">
          <Fade in={true} timeout={800}>
            <Paper
              elevation={12}
              sx={{
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: 3,
                background: 'white',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '4px',
                  background: 'linear-gradient(to right, #1976d2, #512da8)'
                }
              }}
            >
              <Slide direction="down" in={true} timeout={600}>
                <Avatar
                  sx={{
                    m: 1,
                    bgcolor: 'transparent',
                    background: 'linear-gradient(to right, #1976d2, #512da8)',
                    width: 60,
                    height: 60,
                    boxShadow: '0 8px 20px rgba(25, 118, 210, 0.3)'
                  }}
                >
                  <LockOutlined sx={{ fontSize: 30 }} />
                </Avatar>
              </Slide>

              <Typography
                component="h1"
                variant="h4"
                sx={{
                  mb: 1,
                  fontWeight: 700,
                  background: 'linear-gradient(to right, #1976d2, #512da8)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                Sign In
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Enter your credentials to access your account
              </Typography>

              {error && (
                <Fade in={!!error}>
                  <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                    {error}
                  </Alert>
                </Fade>
              )}

              <Box component="form" onSubmit={handleLogin} sx={{ width: '100%' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email color="action" />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: '#1976d2'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2'
                      }
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#1976d2'
                    }
                  }}
                />

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlined color="action" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: '#1976d2'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2'
                      }
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#1976d2'
                    }
                  }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1, mb: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="remember"
                        color="primary"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                        sx={{
                          color: '#1976d2',
                          '&.Mui-checked': {
                            color: '#1976d2'
                          }
                        }}
                      />
                    }
                    label="Remember me"
                  />
                  {/* <Link href="#" variant="body2" sx={{ color: '#1976d2' }}>
                    Forgot password?
                  </Link> */}
                </Box>

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={isLoading}
                  sx={{
                    mt: 2,
                    mb: 3,
                    py: 1.5,
                    background: 'linear-gradient(to right, #1976d2, #512da8)',
                    borderRadius: 2,
                    textTransform: 'none',
                    fontSize: '16px',
                    fontWeight: 600,
                    boxShadow: '0 4px 15px rgba(25, 118, 210, 0.4)',
                    '&:hover': {
                      background: 'linear-gradient(to right, #1565c0, #4527a0)',
                      boxShadow: '0 6px 20px rgba(25, 118, 210, 0.6)',
                      transform: 'translateY(-2px)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  {isLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    'Sign In'
                  )}
                </Button>

                {/* <Divider sx={{ my: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    or continue with
                  </Typography>
                </Divider> */}

                {/* <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => handleSocialLogin('Google')}
                    sx={{
                      py: 1,
                      borderColor: '#db4437',
                      color: '#db4437',
                      '&:hover': {
                        borderColor: '#db4437',
                        backgroundColor: 'rgba(219, 68, 55, 0.04)'
                      }
                    }}
                  >
                    <Google sx={{ mr: 1 }} />
                    Google
                  </Button>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => handleSocialLogin('Facebook')}
                    sx={{
                      py: 1,
                      borderColor: '#3b5998',
                      color: '#3b5998',
                      '&:hover': {
                        borderColor: '#3b5998',
                        backgroundColor: 'rgba(59, 89, 152, 0.04)'
                      }
                    }}
                  >
                    <Facebook sx={{ mr: 1 }} />
                    Facebook
                  </Button>
                </Box> */}

                <Box textAlign="center">
                  <Typography variant="body2" color="text.secondary">
                    Don't have an account?{' '}
                    <Link href="/sign-up" sx={{ color: '#1976d2', fontWeight: 600 }}>
                      Sign up
                    </Link>
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Fade>
        </Container>
      </Box>

      {/* Footer */}
    
    </Box>
  );
}